import { img, readdy } from '@/utils/images';

export const storesHero = {
  title: '每一位成员，都是品牌专业实力的担当',
  subtitle: 'MANAGEMENT TEAM',
  description: '汇聚行业精英，以专业底蕴与管理智慧驱动品牌前行。从战略决策到落地执行，每一位运营总监都是颜轻至核心竞争力的承载者。',
  imagePrompt: 'Professional business team portrait in warm beige and cream brand colors, diverse East Asian professionals in modern office setting, confident expressions, collaborative atmosphere, soft natural lighting through large windows, editorial corporate photography with shallow depth of field, elegant minimal interior design',
};

const basePrompt = 'Professional female slimming consultant store manager in warm beige uniform, portrait orientation 3:4 aspect ratio, smiling warmly, clean modern wellness store background with soft natural lighting, elegant minimal interior, East Asian woman, professional portrait photography with shallow depth of field';

export const storeManagers = [
  {
    name: '沈晓欢',
    position: '运营总监',
    city: '西安',
    store: '西安南门店',
    experience: '8年从业经验',
    philosophy: '用专业和耐心陪伴每一位顾客，让健康管理成为温暖的生活方式。',
    imagePrompt: 'Professional female slimming consultant store manager in warm beige uniform, smiling warmly standing at the reception of a clean modern wellness store, soft natural lighting, elegant interior, East Asian woman around 35, professional portrait',
    imageUrl: img('readdy/0d65b4f21371b2532443ebe637fbfe3d.png'),
  },
  {
    name: '周书兰',
    position: '运营总监',
    city: '西安',
    store: '罗马花园店',
    experience: '6年从业经验',
    philosophy: '健康纤体是一场温暖的陪伴，而不是冰冷的数字游戏。',
    imagePrompt: 'Confident professional female health store manager with gentle smile, in bright modern wellness center interior with beige decor, East Asian woman around 32, warm soft lighting, professional portrait photography',
    imageUrl: img('readdy/e758677afbe66cd836503e545643ce3a.png'),
  },
  {
    name: '张侠',
    position: '运营总监',
    city: '西安',
    store: '浐灞新城店',
    experience: '10年从业经验',
    philosophy: '每一位顾客都值得被用心对待，每一次服务都是一份责任。',
    imagePrompt: 'Experienced female wellness store manager in elegant beige professional attire, warm confident expression, standing in upscale spa-like store environment with plants, East Asian woman around 40, soft diffused lighting, professional portrait',
    imageUrl: img('readdy/9a9cc5e82197bf8999b78b25f1673846.png'),
  },
  {
    name: '孙建红',
    position: '运营总监',
    city: '西安',
    store: '西安文景凤十店',
    experience: '5年从业经验',
    philosophy: '让健康管理成为一种自然而愉悦的生活方式。',
    imagePrompt: 'Young professional female health store manager smiling naturally, in bright modern wellness store with plants and warm decor, East Asian woman around 30, clean natural lighting, lifestyle portrait style',
    imageUrl: img('readdy/d7fd5fa086b10ae47ef4b1efece89d03.png'),
  },
  {
    name: '连娟宁',
    position: '运营总监',
    city: '西安',
    store: '西安南小巷店',
    experience: '7年从业经验',
    philosophy: '细节决定体验，专业成就信赖。',
    imagePrompt: 'Professional female store manager in cream color uniform, welcoming smile, standing in newly opened elegant wellness store with modern design, East Asian woman around 34, bright natural lighting, professional portrait',
    imageUrl: img('readdy/15719b60db2da6f6e91b4714e5b9282a.png'),
  },
  {
    name: '樊桦',
    position: '运营总监',
    city: '西安',
    store: '哈尔滨南岗店',
    experience: '9年从业经验',
    philosophy: '在健康管理的路上，我愿意做每位顾客最可靠的同路人。',
    imagePrompt: 'Mature professional female wellness store manager with warm smile, in elegant bright store interior with cozy atmosphere, East Asian woman around 38, soft warm lighting, professional portrait photography',
    imageUrl: img('readdy/1f6bb05b216eff6f0986a57d3ad6dad7.png'),
  },
  {
    name: '邵婕',
    position: '运营总监',
    city: '西安',
    store: '成都春熙路店',
    experience: '11年从业经验',
    philosophy: '美丽没有标准答案，健康才是最美的底色。',
    imagePrompt: 'Elegant professional female wellness store manager in beige uniform, gentle confident smile, standing in upscale spa reception area with fresh flowers, East Asian woman around 37, soft natural light, professional portrait photography',
    imageUrl: img('readdy/d366ad1a8b50da13e985cf06efced373.png'),
  },
  {
    name: '姜洋',
    position: '运营总监',
    city: '西安',
    store: '郑州金水店',
    experience: '7年从业经验',
    philosophy: '每一次蜕变背后，都是日复一日的专业与匠心。',
    imagePrompt: 'Professional female store manager in cream uniform with warm smile, in modern bright wellness store interior with warm lighting, East Asian woman around 33, professional portrait with natural expression',
    imageUrl: img('readdy/116b7bbcb88bbe490008dd681c776c8b.png'),
  },
  {
    name: '梅凤惠',
    position: '运营总监',
    city: '西安',
    store: '武汉光谷店',
    experience: '6年从业经验',
    philosophy: '用科学和温度，守护每一份变美的期待。',
    imagePrompt: 'Young professional female wellness center manager smiling naturally, in bright modern store with clean minimalist decor and green plants, East Asian woman around 31, lifestyle portrait with warm tones',
    imageUrl: img('readdy/c105dd05f2e6f5acace46ece14115fb9.png'),
  },
  {
    name: '徐继媛',
    position: '运营总监',
    city: '西安',
    store: '西安高新店',
    experience: '12年从业经验',
    philosophy: '十二年深耕，只为一个值得信赖的品牌。',
    imagePrompt: 'Mature confident female wellness store senior manager in elegant beige attire, at upscale spa reception with marble desk and flowers, East Asian woman around 43, professional portrait with warm lighting',
    imageUrl: img('readdy/9d71e207f08896c9392ca56a166410e5.png'),
  },
  {
    name: '张凤侠',
    position: '运营总监',
    city: '西安',
    store: '五一广场店',
    experience: '5年从业经验',
    philosophy: '让每一次服务都成为顾客愿意分享的美好体验。',
    imagePrompt: 'Youthful professional female health store manager with bright smile, in contemporary wellness store with natural materials and warm beige tones, East Asian woman around 29, fresh lifestyle portrait photography',
    imageUrl: img('readdy/2534e222e8eea7f98aec4b299a019f19.png'),
  },
  {
    name: '李玉芹',
    position: '运营总监',
    city: '西安',
    store: '重庆解放碑店',
    experience: '8年从业经验',
    philosophy: '用专业的态度做有温度的服务。',
    imagePrompt: 'Professional female wellness store manager in cream uniform with confident warm smile, in modern bright spa interior with warm lighting and plants, East Asian woman around 35, professional portrait',
    imageUrl: img('readdy/e10009ddc8de611c8b5e06f3a42ea33b.png'),
  },
  {
    name: '陈思雨',
    position: '运营总监',
    city: '武汉',
    store: '武汉街道口店',
    experience: '6年从业经验',
    philosophy: '纤体不是终点，自信才是最美的回报。',
    imagePrompt: basePrompt + ' East Asian woman around 32',
    imageUrl: '',
  },
  {
    name: '刘婉婷',
    position: '运营总监',
    city: '成都',
    store: '成都天府广场店',
    experience: '9年从业经验',
    philosophy: '陪伴每一位顾客，走过蜕变的每一个瞬间。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '王丽华',
    position: '运营总监',
    city: '重庆',
    store: '重庆江北店',
    experience: '10年从业经验',
    philosophy: '十年初心不改，只为做好健康管理这一件事。',
    imagePrompt: basePrompt + ' East Asian woman around 38',
    imageUrl: '',
  },
  {
    name: '赵雅琴',
    position: '运营总监',
    city: '郑州',
    store: '郑州二七店',
    experience: '7年从业经验',
    philosophy: '用心倾听每一位顾客的心声，专业回应每一份期待。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '杨晓琳',
    position: '运营总监',
    city: '长沙',
    store: '长沙五一店',
    experience: '5年从业经验',
    philosophy: '让健康管理融入日常，让好习惯成为本能。',
    imagePrompt: basePrompt + ' East Asian woman around 30',
    imageUrl: '',
  },
  {
    name: '马静怡',
    position: '运营总监',
    city: '西安',
    store: '西安雁塔店',
    experience: '8年从业经验',
    philosophy: '顾客的笑容，是对我工作最大的肯定。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '黄丽芳',
    position: '运营总监',
    city: '南京',
    store: '南京新街口店',
    experience: '9年从业经验',
    philosophy: '每一次服务，都是一次心与心的交流。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '林雅文',
    position: '运营总监',
    city: '杭州',
    store: '杭州西湖店',
    experience: '6年从业经验',
    philosophy: '以专业为根基，以真诚为温度。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '吴春梅',
    position: '运营总监',
    city: '西安',
    store: '西安未央店',
    experience: '11年从业经验',
    philosophy: '十一年如一日，只为看到顾客自信的模样。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '何秀英',
    position: '运营总监',
    city: '合肥',
    store: '合肥滨湖店',
    experience: '7年从业经验',
    philosophy: '把每一件小事做到极致，就是不平凡。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '朱敏丽',
    position: '运营总监',
    city: '西安',
    store: '西安长安店',
    experience: '8年从业经验',
    philosophy: '以服务打动人心，以效果赢得信赖。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '郭慧芳',
    position: '运营总监',
    city: '武汉',
    store: '武汉徐东店',
    experience: '10年从业经验',
    philosophy: '每一位顾客都是独特的花朵，需要不同的呵护方式。',
    imagePrompt: basePrompt + ' East Asian woman around 40',
    imageUrl: '',
  },
  {
    name: '谢晓燕',
    position: '运营总监',
    city: '成都',
    store: '成都锦里店',
    experience: '5年从业经验',
    philosophy: '年轻不是资本，专业才是底气。',
    imagePrompt: basePrompt + ' East Asian woman around 28',
    imageUrl: '',
  },
  {
    name: '郑丽娟',
    position: '运营总监',
    city: '西安',
    store: '西安经开店',
    experience: '12年从业经验',
    philosophy: '见证顾客的改变，就是我最大的幸福。',
    imagePrompt: basePrompt + ' East Asian woman around 41',
    imageUrl: '',
  },
  {
    name: '潘美霞',
    position: '运营总监',
    city: '济南',
    store: '济南泉城店',
    experience: '6年从业经验',
    philosophy: '健康管理是一门艺术，需要用心去雕琢。',
    imagePrompt: basePrompt + ' East Asian woman around 32',
    imageUrl: '',
  },
  {
    name: '邓文静',
    position: '运营总监',
    city: '西安',
    store: '西安曲江店',
    experience: '9年从业经验',
    philosophy: '用最温柔的方式，做最专业的事。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '唐佳琪',
    position: '运营总监',
    city: '重庆',
    store: '重庆南坪店',
    experience: '7年从业经验',
    philosophy: '服务无小事，细节见真章。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '蒋丽娜',
    position: '运营总监',
    city: '西安',
    store: '西安碑林店',
    experience: '8年从业经验',
    philosophy: '用心服务，让健康管理成为温暖的习惯。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '彭艳玲',
    position: '运营总监',
    city: '郑州',
    store: '郑州中原店',
    experience: '10年从业经验',
    philosophy: '十年磨一剑，专注做好健康管理服务。',
    imagePrompt: basePrompt + ' East Asian woman around 38',
    imageUrl: '',
  },
  {
    name: '汪晓晴',
    position: '运营总监',
    city: '长沙',
    store: '长沙星沙店',
    experience: '5年从业经验',
    philosophy: '每一次遇见，都是缘分；每一次服务，都是承诺。',
    imagePrompt: basePrompt + ' East Asian woman around 29',
    imageUrl: '',
  },
  {
    name: '曹雪梅',
    position: '运营总监',
    city: '西安',
    store: '西安莲湖店',
    experience: '11年从业经验',
    philosophy: '健康不是终点，而是美好生活的起点。',
    imagePrompt: basePrompt + ' East Asian woman around 40',
    imageUrl: '',
  },
  {
    name: '石丽萍',
    position: '运营总监',
    city: '太原',
    store: '太原迎泽店',
    experience: '7年从业经验',
    philosophy: '纤体之路，我愿意做你最贴心的同行者。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '陆秋月',
    position: '运营总监',
    city: '西安',
    store: '西安灞桥店',
    experience: '6年从业经验',
    philosophy: '专业与真诚，是我给顾客最踏实的承诺。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '韩晓敏',
    position: '运营总监',
    city: '成都',
    store: '成都高新店',
    experience: '9年从业经验',
    philosophy: '健康管理的本质，是用科学的方法做温暖的事。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '赖秀娟',
    position: '运营总监',
    city: '西安',
    store: '西安新城区店',
    experience: '8年从业经验',
    philosophy: '让每一次改变都被看见，让每一份努力都有回报。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '侯雪莲',
    position: '运营总监',
    city: '兰州',
    store: '兰州城关店',
    experience: '10年从业经验',
    philosophy: '扎根西北，用专业服务好每一位家乡顾客。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '丁晓芳',
    position: '运营总监',
    city: '武汉',
    store: '武汉汉口店',
    experience: '7年从业经验',
    philosophy: '用数据说话，用效果证明。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '田小娟',
    position: '运营总监',
    city: '成都',
    store: '成都武侯店',
    experience: '8年从业经验',
    philosophy: '健康是最长情的陪伴，纤体是最温柔的改变。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '沈美玲',
    position: '运营总监',
    city: '重庆',
    store: '重庆渝北店',
    experience: '9年从业经验',
    philosophy: '每一克的变化，都是努力的勋章。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '余秀兰',
    position: '运营总监',
    city: '西安',
    store: '西安临潼店',
    experience: '11年从业经验',
    philosophy: '用心守护每一份健康的期待。',
    imagePrompt: basePrompt + ' East Asian woman around 40',
    imageUrl: '',
  },
  {
    name: '曾燕玲',
    position: '运营总监',
    city: '郑州',
    store: '郑州郑东店',
    experience: '6年从业经验',
    philosophy: '纤体之路，用专业之光点亮每一步。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '卢佳慧',
    position: '运营总监',
    city: '长沙',
    store: '长沙岳麓店',
    experience: '8年从业经验',
    philosophy: '让每一位顾客都能遇见更好的自己。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '谭丽红',
    position: '运营总监',
    city: '西安',
    store: '西安鄠邑店',
    experience: '10年从业经验',
    philosophy: '服务无止境，用心每一天。',
    imagePrompt: basePrompt + ' East Asian woman around 38',
    imageUrl: '',
  },
  {
    name: '范晓云',
    position: '运营总监',
    city: '南京',
    store: '南京鼓楼店',
    experience: '7年从业经验',
    philosophy: '用温暖的方式，做科学的纤体。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '闫雪萍',
    position: '运营总监',
    city: '杭州',
    store: '杭州滨江店',
    experience: '9年从业经验',
    philosophy: '每一次进步都值得被记录，每一个改变都值得被赞美。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '万淑琴',
    position: '运营总监',
    city: '西安',
    store: '西安航天城店',
    experience: '6年从业经验',
    philosophy: '做顾客心中最值得信赖的健康顾问。',
    imagePrompt: basePrompt + ' East Asian woman around 32',
    imageUrl: '',
  },
  {
    name: '邹秋菊',
    position: '运营总监',
    city: '合肥',
    store: '合肥政务店',
    experience: '8年从业经验',
    philosophy: '让专业成为习惯，让服务成为本能。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '熊丽',
    position: '运营总监',
    city: '西安',
    store: '西安浐灞店',
    experience: '10年从业经验',
    philosophy: '十年如一日，以匠心致初心。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '史红梅',
    position: '运营总监',
    city: '武汉',
    store: '武汉武昌店',
    experience: '7年从业经验',
    philosophy: '用专业铸就信赖，用真诚温暖人心。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '罗雪峰',
    position: '运营总监',
    city: '成都',
    store: '成都金牛店',
    experience: '11年从业经验',
    philosophy: '健康管理不是一时兴起，而是一生的陪伴。',
    imagePrompt: basePrompt + ' East Asian woman around 41',
    imageUrl: '',
  },
  {
    name: '秦晓丽',
    position: '运营总监',
    city: '重庆',
    store: '重庆沙坪坝店',
    experience: '6年从业经验',
    philosophy: '年轻的活力，专业的服务。',
    imagePrompt: basePrompt + ' East Asian woman around 30',
    imageUrl: '',
  },
  {
    name: '贾秀珍',
    position: '运营总监',
    city: '西安',
    store: '西安阎良店',
    experience: '12年从业经验',
    philosophy: '十二年见证无数蜕变，初心从未改变。',
    imagePrompt: basePrompt + ' East Asian woman around 42',
    imageUrl: '',
  },
  {
    name: '尹春燕',
    position: '运营总监',
    city: '济南',
    store: '济南历下店',
    experience: '8年从业经验',
    philosophy: '纤体是科学，服务是艺术。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '白静',
    position: '运营总监',
    city: '西安',
    store: '西安纺织城店',
    experience: '7年从业经验',
    philosophy: '用专业的态度，做有温度的服务。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '段巧云',
    position: '运营总监',
    city: '太原',
    store: '太原小店店',
    experience: '9年从业经验',
    philosophy: '每一次蜕变，都值得最好的陪伴。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '龚英',
    position: '运营总监',
    city: '西安',
    store: '西安大唐西市店',
    experience: '10年从业经验',
    philosophy: '健康之路，我与顾客并肩同行。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '邱桂香',
    position: '运营总监',
    city: '郑州',
    store: '郑州惠济店',
    experience: '6年从业经验',
    philosophy: '用最真诚的服务，换最满意的笑容。',
    imagePrompt: basePrompt + ' East Asian woman around 32',
    imageUrl: '',
  },
  {
    name: '廖春霞',
    position: '运营总监',
    city: '长沙',
    store: '长沙开福店',
    experience: '8年从业经验',
    philosophy: '让每个人都能轻松拥有健康体态。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '魏雪',
    position: '运营总监',
    city: '西安',
    store: '西安北郊店',
    experience: '7年从业经验',
    philosophy: '健康不是目标，而是一种生活状态。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '牟艳红',
    position: '运营总监',
    city: '兰州',
    store: '兰州安宁店',
    experience: '9年从业经验',
    philosophy: '西北的风沙磨砺出最坚韧的专业品质。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '夏文娟',
    position: '运营总监',
    city: '西安',
    store: '西安电子城店',
    experience: '8年从业经验',
    philosophy: '在变美的路上，请让我做你的领航人。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '孔淑华',
    position: '运营总监',
    city: '合肥',
    store: '合肥包河店',
    experience: '10年从业经验',
    philosophy: '坚守品质，不负每一份信任。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '齐桂英',
    position: '运营总监',
    city: '西安',
    store: '西安西咸店',
    experience: '11年从业经验',
    philosophy: '十一年，用心做好一件事。',
    imagePrompt: basePrompt + ' East Asian woman around 41',
    imageUrl: '',
  },
  {
    name: '常丽华',
    position: '运营总监',
    city: '武汉',
    store: '武汉青山店',
    experience: '6年从业经验',
    philosophy: '年轻的心态，成熟的技能。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '尤艳',
    position: '运营总监',
    city: '成都',
    store: '成都青羊店',
    experience: '8年从业经验',
    philosophy: '用数据追踪改变，用专业见证蜕变。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '符玉兰',
    position: '运营总监',
    city: '重庆',
    store: '重庆九龙坡店',
    experience: '7年从业经验',
    philosophy: '山城人的直爽，用在服务上就是真诚。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '舒晓玲',
    position: '运营总监',
    city: '西安',
    store: '西安三桥店',
    experience: '9年从业经验',
    philosophy: '让每一位顾客带着笑容和自信离开。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '项美华',
    position: '运营总监',
    city: '南京',
    store: '南京秦淮店',
    experience: '8年从业经验',
    philosophy: '古都底蕴，现代健康。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '毕秀芳',
    position: '运营总监',
    city: '杭州',
    store: '杭州萧山店',
    experience: '10年从业经验',
    philosophy: '江南温婉，服务如诗。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '祝秋香',
    position: '运营总监',
    city: '西安',
    store: '西安大兴新区店',
    experience: '6年从业经验',
    philosophy: '因为热爱，所以专注。',
    imagePrompt: basePrompt + ' East Asian woman around 32',
    imageUrl: '',
  },
  {
    name: '涂芳',
    position: '运营总监',
    city: '济南',
    store: '济南天桥店',
    experience: '7年从业经验',
    philosophy: '泉水般清澈的服务，沁人心脾。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '童桂兰',
    position: '运营总监',
    city: '西安',
    store: '西安土门店',
    experience: '11年从业经验',
    philosophy: '时光可以老去，但专业永远年轻。',
    imagePrompt: basePrompt + ' East Asian woman around 42',
    imageUrl: '',
  },
  {
    name: '洪晓英',
    position: '运营总监',
    city: '太原',
    store: '太原万柏林店',
    experience: '8年从业经验',
    philosophy: '山西人的朴实，成就最踏实的服务。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '甘玉蓉',
    position: '运营总监',
    city: '西安',
    store: '西安高新二期店',
    experience: '9年从业经验',
    philosophy: '科技赋能健康，专业守护美丽。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '荣晓燕',
    position: '运营总监',
    city: '郑州',
    store: '郑州上街店',
    experience: '6年从业经验',
    philosophy: '中原大地，用最朴实的服务打动人心。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '谷丽丽',
    position: '运营总监',
    city: '长沙',
    store: '长沙雨花店',
    experience: '7年从业经验',
    philosophy: '热辣湘妹子，用热情点燃健康之火。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '池秀云',
    position: '运营总监',
    city: '西安',
    store: '西安长安大学城店',
    experience: '8年从业经验',
    philosophy: '青春的气息，专业的实力。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '温玉洁',
    position: '运营总监',
    city: '武汉',
    store: '武汉汉阳店',
    experience: '10年从业经验',
    philosophy: '让每位顾客成为健康管理的受益者。',
    imagePrompt: basePrompt + ' East Asian woman around 38',
    imageUrl: '',
  },
  {
    name: '曲晓琴',
    position: '运营总监',
    city: '成都',
    store: '成都双流店',
    experience: '9年从业经验',
    philosophy: '巴蜀人的热情，融入每一次服务。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '师凤兰',
    position: '运营总监',
    city: '西安',
    store: '西安大学城店',
    experience: '7年从业经验',
    philosophy: '让健康管理成为年轻人的新时尚。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '卓丽娟',
    position: '运营总监',
    city: '重庆',
    store: '重庆大渡口店',
    experience: '8年从业经验',
    philosophy: '火锅之都，纤体也可以很热辣。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '易红霞',
    position: '运营总监',
    city: '西安',
    store: '西安渭滨店',
    experience: '10年从业经验',
    philosophy: '坚守初心，让服务回归本真。',
    imagePrompt: basePrompt + ' East Asian woman around 40',
    imageUrl: '',
  },
  {
    name: '芦雪',
    position: '运营总监',
    city: '兰州',
    store: '兰州西固店',
    experience: '6年从业经验',
    philosophy: '用最真诚的心，做最专业的事。',
    imagePrompt: basePrompt + ' East Asian woman around 30',
    imageUrl: '',
  },
  {
    name: '叶春梅',
    position: '运营总监',
    city: '西安',
    store: '西安胡家庙店',
    experience: '12年从业经验',
    philosophy: '十二年如一日，专注健康管理。',
    imagePrompt: basePrompt + ' East Asian woman around 43',
    imageUrl: '',
  },
  {
    name: '兰晓红',
    position: '运营总监',
    city: '合肥',
    store: '合肥瑶海店',
    experience: '7年从业经验',
    philosophy: '每一份坚持，都会开花结果。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '翟小琴',
    position: '运营总监',
    city: '西安',
    store: '西安龙首原店',
    experience: '9年从业经验',
    philosophy: '在变美的路上，做一个温暖的引路人。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '安秀英',
    position: '运营总监',
    city: '南京',
    store: '南京建邺店',
    experience: '8年从业经验',
    philosophy: '金陵风华，健康相伴。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '鲍雪莲',
    position: '运营总监',
    city: '杭州',
    store: '杭州余杭店',
    experience: '10年从业经验',
    philosophy: '西湖边的健康管家，温柔而坚定。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '盛艳秋',
    position: '运营总监',
    city: '西安',
    store: '西安常宁新区店',
    experience: '6年从业经验',
    philosophy: '让专业与美丽一路同行。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '汤桂芳',
    position: '运营总监',
    city: '济南',
    store: '济南槐荫店',
    experience: '8年从业经验',
    philosophy: '千佛山下，用专业守护健康。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '武晓慧',
    position: '运营总监',
    city: '西安',
    store: '西安凤城路店',
    experience: '11年从业经验',
    philosophy: '不忘初心，方得始终。',
    imagePrompt: basePrompt + ' East Asian woman around 40',
    imageUrl: '',
  },
  {
    name: '阮春香',
    position: '运营总监',
    city: '太原',
    store: '太原杏花岭店',
    experience: '7年从业经验',
    philosophy: '以专业赢得尊重，以服务赢得口碑。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '邢桂珍',
    position: '运营总监',
    city: '西安',
    store: '西安太华路店',
    experience: '9年从业经验',
    philosophy: '九年的沉淀，只为更好的服务。',
    imagePrompt: basePrompt + ' East Asian woman around 38',
    imageUrl: '',
  },
  {
    name: '桑丽娜',
    position: '运营总监',
    city: '郑州',
    store: '郑州管城店',
    experience: '6年从业经验',
    philosophy: '用微笑迎接每一位顾客。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '米秀娟',
    position: '运营总监',
    city: '长沙',
    store: '长沙望城店',
    experience: '8年从业经验',
    philosophy: '湘江之畔，做好健康守门人。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '耿冬梅',
    position: '运营总监',
    city: '西安',
    store: '西安红光路店',
    experience: '10年从业经验',
    philosophy: '十年陪伴，见证无数美好蜕变。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '聂晓娟',
    position: '运营总监',
    city: '武汉',
    store: '武汉沌口店',
    experience: '7年从业经验',
    philosophy: '用专业说话，用效果服人。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '覃玉梅',
    position: '运营总监',
    city: '成都',
    store: '成都成华店',
    experience: '9年从业经验',
    philosophy: '慢生活里，做最专业的健康顾问。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '郝春艳',
    position: '运营总监',
    city: '重庆',
    store: '重庆巴南店',
    experience: '8年从业经验',
    philosophy: '山城雾都，健康之光亮如晨曦。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '虞小丽',
    position: '运营总监',
    city: '西安',
    store: '西安鱼化寨店',
    experience: '6年从业经验',
    philosophy: '让改变从今天开始。',
    imagePrompt: basePrompt + ' East Asian woman around 30',
    imageUrl: '',
  },
  {
    name: '章丽萍',
    position: '运营总监',
    city: '合肥',
    store: '合肥庐阳店',
    experience: '10年从业经验',
    philosophy: '徽商精神，诚信服务。',
    imagePrompt: basePrompt + ' East Asian woman around 40',
    imageUrl: '',
  },
  {
    name: '牛慧敏',
    position: '运营总监',
    city: '西安',
    store: '西安辛家庙店',
    experience: '8年从业经验',
    philosophy: '用牛一样的勤奋，做蜜蜂一样甜蜜的服务。',
    imagePrompt: basePrompt + ' East Asian woman around 35',
    imageUrl: '',
  },
  {
    name: '连倩',
    position: '运营总监',
    city: '南京',
    store: '南京玄武店',
    experience: '7年从业经验',
    philosophy: '紫金山下，健康常伴。',
    imagePrompt: basePrompt + ' East Asian woman around 33',
    imageUrl: '',
  },
  {
    name: '倪秋萍',
    position: '运营总监',
    city: '杭州',
    store: '杭州拱墅店',
    experience: '9年从业经验',
    philosophy: '运河之畔，做有温度的健康服务。',
    imagePrompt: basePrompt + ' East Asian woman around 37',
    imageUrl: '',
  },
  {
    name: '乔玉',
    position: '运营总监',
    city: '西安',
    store: '西安东郊店',
    experience: '11年从业经验',
    philosophy: '十一年，用行动诠释什么是坚持。',
    imagePrompt: basePrompt + ' East Asian woman around 41',
    imageUrl: '',
  },
  {
    name: '陶晓红',
    position: '运营总监',
    city: '济南',
    store: '济南长清店',
    experience: '6年从业经验',
    philosophy: '大明湖畔，绽放健康之美。',
    imagePrompt: basePrompt + ' East Asian woman around 32',
    imageUrl: '',
  },
  {
    name: '毛秀珍',
    position: '运营总监',
    city: '西安',
    store: '西安明德门店',
    experience: '10年从业经验',
    philosophy: '以专业拔尖，以服务取胜。',
    imagePrompt: basePrompt + ' East Asian woman around 39',
    imageUrl: '',
  },
  {
    name: '霍丽敏',
    position: '运营总监',
    city: '太原',
    store: '太原尖草坪店',
    experience: '7年从业经验',
    philosophy: '汾河之滨，用心做好健康服务。',
    imagePrompt: basePrompt + ' East Asian woman around 34',
    imageUrl: '',
  },
  {
    name: '钟雪琴',
    position: '运营总监',
    city: '西安',
    store: '西安长安南路店',
    experience: '8年从业经验',
    philosophy: '让健康成为一种信仰。',
    imagePrompt: basePrompt + ' East Asian woman around 36',
    imageUrl: '',
  },
  {
    name: '傅丽琼',
    position: '运营总监',
    city: '郑州',
    store: '郑州高新店',
    experience: '9年从业经验',
    philosophy: '嵩山之下，用匠心铸就服务品质。',
    imagePrompt: basePrompt + ' East Asian woman around 38',
    imageUrl: '',
  },
  {
    name: '彭秀兰',
    position: '运营总监',
    city: '长沙',
    store: '长沙天心店',
    experience: '6年从业经验',
    philosophy: '橘子洲头，立健康之志。',
    imagePrompt: basePrompt + ' East Asian woman around 31',
    imageUrl: '',
  },
  {
    name: '袁春芳',
    position: '运营总监',
    city: '西安',
    store: '西安翠华路店',
    experience: '12年从业经验',
    philosophy: '十二年风雨，初心依旧灿烂。',
    imagePrompt: basePrompt + ' East Asian woman around 42',
    imageUrl: '',
  },
];

export const storeGallery = [
  {
    title: '品牌旗舰店',
    location: '西安曲江',
    imagePrompt: 'Elegant modern wellness chain store reception area with warm beige and cream color scheme, marble reception desk with fresh flowers, soft ambient lighting, upscale comfortable waiting area with plants, clean minimal design, architectural interior photography',
  },
  {
    title: '护理室',
    location: '标准配置',
    imagePrompt: 'Clean serene individual treatment room in wellness center, warm beige walls, comfortable treatment bed with cream linens, soft diffused lighting, minimal elegant decor with subtle Chinese elements, spa interior photography',
  },
  {
    title: '中医调理区',
    location: '经络护理',
    imagePrompt: 'Traditional Chinese wellness treatment area in modern setting, warm wood tones and beige colors, acupuncture charts on wall, herbal elements, serene atmosphere with natural light, professional wellness center interior',
  },
  {
    title: '顾客休息区',
    location: '舒适环境',
    imagePrompt: 'Cozy elegant customer lounge area in wellness center, comfortable cream sofas with beige pillows, warm lighting, plants, tea ceremony corner, magazines on wooden table, relaxing upscale atmosphere, interior design photography',
  },
  {
    title: '体测评估室',
    location: '科学检测',
    imagePrompt: 'Modern professional body composition analysis room in wellness center, clean white and beige interior, digital health screening equipment, professional atmosphere with warm accent lighting, clinical yet welcoming space',
  },
  {
    title: '培训教室',
    location: '持续赋能',
    imagePrompt: 'Bright modern training classroom in wellness center headquarters, warm beige walls, professional presentation screen, comfortable seating rows, plants, natural daylight from large windows, corporate training facility photography',
  },
];

export const serviceStandards = [
  {
    step: '01',
    title: '预约到店',
    desc: '线上/电话预约，门店前台热情接待，引导至舒适休息区，提供草本茶饮，初步了解顾客需求。',
    icon: 'ri-calendar-check-line',
  },
  {
    step: '02',
    title: '体测评估',
    desc: '使用专业体成分分析仪进行全面检测，获取体脂率、肌肉量、基础代谢等关键数据，建立个人健康档案。',
    icon: 'ri-heart-pulse-line',
  },
  {
    step: '03',
    title: '顾问咨询',
    desc: '资深瘦身顾问一对一沟通，深入了解顾客生活习惯、饮食偏好、健康目标，结合体测数据做综合评估。',
    icon: 'ri-chat-smile-2-line',
  },
  {
    step: '04',
    title: '方案制定',
    desc: '基于评估结果，融合中医经络理论与现代健康管理，为顾客量身定制个性化纤体方案与周期计划。',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '05',
    title: '服务实施',
    desc: '在舒适私密的护理室中进行专业服务，顾问全程陪伴，实时关注顾客感受，确保每一次服务体验。',
    icon: 'ri-home-smile-line',
  },
  {
    step: '06',
    title: '效果追踪',
    desc: '定期复测体成分数据，对比变化趋势，顾问根据进展灵活调整方案，确保健康管理持续有效。',
    icon: 'ri-line-chart-line',
  },
];

export const systemInfo = {
  title: '不只是门店，而是品牌服务体系的完整落地',
  description: '每一家门店的背后，是总部、区域经理、城市经理、门店店长、瘦身顾问五级协同的标准化连锁服务机制。从开业培训到日常运营，从营销策划到售后保障，总部系统化支撑让每一家门店都能为顾客提供始终如一的专业服务。',
  levels: [
    { label: '总部', desc: '战略规划·标准制定·培训赋能' },
    { label: '区域经理', desc: '区域管理·市场拓展·巡店指导' },
    { label: '城市经理', desc: '城市运营·门店督导·资源协调' },
    { label: '门店店长', desc: '门店管理·团队建设·顾客服务' },
    { label: '瘦身顾问', desc: '专业服务·顾客陪伴·方案执行' },
  ],
};